namespace advisorop.services {
    `use strict`;

    export class InvestorPpService {
        static $inject = [`$http`];
        constructor(private $http: ng.IHttpService) {
        }

        requestActivities(activitiesRequest: domains.IActivitiesRequest): ng.IHttpPromise<any> {
            return this.$http.post(`/api/investor/pp/activities`, activitiesRequest);
        };

        requestHoldings(holdingsRequest: domains.IHoldingsRequest): ng.IHttpPromise<any> {
            return this.$http.post(`/api/investor/pp/holdings`, holdingsRequest);
        };
    }
    angular.module(Constants.ADVOP_SERVICES).service(`investorPpService`, InvestorPpService);
}
